/* K9 Unit — quiz d'article. Contrat HTML : spec k9-seo docs/superpowers/specs/2026-10-20-quiz-k9-design.md (mode à
   points, sans data-k9-quiz-mode) et 2026-10-27-quiz-adaptatif-design.md (data-k9-quiz-mode="regles").
   Le bloc [data-k9-quiz] se lit sans script (mini-guide) ; ce script le rend interactif. Bloc invalide ou mode
   inconnu : intact. */
(function () {
  'use strict';
  var DEFAUTS = { resultat: 'Votre résultat :', recommencer: 'Refaire le test', progression: 'Question {n} sur {total}' };

  // « A:3 B:1 » → { A: 3, B: 1 } ; vide → {} ; illisible → null.
  function lirePoints(texte) {
    var points = {};
    var morceaux = String(texte || '').trim().split(/\s+/).filter(Boolean);
    for (var i = 0; i < morceaux.length; i++) {
      var m = /^([^:]+):(-?\d+)$/.exec(morceaux[i]);
      if (!m) return null;
      points[m[1]] = (points[m[1]] || 0) + parseInt(m[2], 10);
    }
    return points;
  }

  // Raison du refus, ou '' si le modèle est jouable.
  function valider(modele) {
    var cles = modele.cles || [];
    if (!modele.questions.length) return 'aucune question';
    if (!cles.length) return 'aucun résultat';
    for (var c = 0; c < cles.length; c++) {
      if (!cles[c]) return 'résultat sans data-resultat';
      if (cles.indexOf(cles[c]) !== c) return 'résultat en double : ' + cles[c];
    }
    for (var q = 0; q < modele.questions.length; q++) {
      var question = modele.questions[q];
      if (!question.texte) return 'question ' + (q + 1) + ' sans data-question';
      if (question.reponses.length < 2) return 'question ' + (q + 1) + ' : moins de deux réponses';
      for (var r = 0; r < question.reponses.length; r++) {
        var reponse = question.reponses[r];
        if (!reponse.texte) return 'question ' + (q + 1) + ' : réponse vide';
        if (!reponse.points) return 'question ' + (q + 1) + ' : data-points illisible';
        for (var cle in reponse.points) {
          if (cles.indexOf(cle) < 0) return 'question ' + (q + 1) + ' : clé inconnue ' + cle;
        }
      }
    }
    return '';
  }

  // Total le plus élevé ; égalité : le premier dans l'ordre des résultats.
  function gagnant(totaux, cles) {
    var meilleur = cles[0];
    for (var i = 1; i < cles.length; i++) {
      if ((totaux[cles[i]] || 0) > (totaux[meilleur] || 0)) meilleur = cles[i];
    }
    return meilleur;
  }

  function enfants(parent, tag) {
    return Array.prototype.filter.call(parent.children, function (n) { return n.tagName === tag; });
  }

  function enfant(parent, classe) {
    return Array.prototype.filter.call(parent.children, function (n) { return n.classList.contains(classe); })[0] || null;
  }

  function lire(racine) {
    var liste = enfant(racine, 'k9-quiz__questions');
    var resultats = enfant(racine, 'k9-quiz__resultats');
    var questions = liste ? enfants(liste, 'LI').map(function (li) {
      var ul = enfants(li, 'UL')[0];
      return {
        texte: (li.getAttribute('data-question') || '').trim(),
        reponses: ul ? enfants(ul, 'LI').map(function (r) {
          return { texte: r.textContent.trim(), points: lirePoints(r.getAttribute('data-points')) };
        }) : []
      };
    }) : [];
    var items = resultats ? enfants(resultats, 'LI') : [];
    return {
      resultats: resultats,
      items: items,
      questions: questions,
      cles: items.map(function (li) { return (li.getAttribute('data-resultat') || '').trim(); })
    };
  }

  function initialiser(racine) {
    if (racine.hasAttribute('data-k9-quiz-pret')) return false;
    var mode = racine.getAttribute('data-k9-quiz-mode');
    if (mode === 'regles') return initialiserRegles(racine);
    if (mode !== null && mode !== 'points') {
      console.warn('[k9-quiz] bloc laissé tel quel : mode inconnu ' + mode);
      return false;
    }
    var modele = lire(racine);
    var raison = modele.resultats ? valider(modele) : 'liste des résultats absente';
    if (raison) {
      console.warn('[k9-quiz] bloc laissé tel quel : ' + raison);
      return false;
    }
    racine.setAttribute('data-k9-quiz-pret', '');
    var doc = racine.ownerDocument;
    var textes = {
      resultat: racine.getAttribute('data-texte-resultat') || DEFAUTS.resultat,
      recommencer: racine.getAttribute('data-texte-recommencer') || DEFAUTS.recommencer,
      progression: racine.getAttribute('data-texte-progression') || DEFAUTS.progression
    };
    function el(tag, classe, texte) {
      var n = doc.createElement(tag);
      if (classe) n.className = classe;
      if (texte != null) n.textContent = texte;
      return n;
    }
    var jeu = el('div', 'k9-quiz__jeu');
    var question = el('p', 'k9-quiz__question');
    question.setAttribute('tabindex', '-1');
    var progression = el('span', 'k9-quiz__progression');
    var libelle = el('span', 'k9-quiz__libelle');
    question.appendChild(progression);
    question.appendChild(libelle);
    var reponses = el('ul', 'k9-quiz__reponses');
    jeu.appendChild(question);
    jeu.appendChild(reponses);
    var annonce = el('p', 'k9-quiz__annonce');
    annonce.setAttribute('tabindex', '-1');
    var recommencer = el('button', 'k9-quiz__recommencer', textes.recommencer);
    recommencer.type = 'button';
    racine.insertBefore(jeu, modele.resultats);
    racine.insertBefore(annonce, modele.resultats);
    racine.appendChild(recommencer);

    var etape = 0;
    var totaux = {};

    function poser(focus) {
      var q = modele.questions[etape];
      progression.textContent = textes.progression
        .replace('{n}', String(etape + 1)).replace('{total}', String(modele.questions.length));
      libelle.textContent = q.texte;
      while (reponses.firstChild) reponses.removeChild(reponses.firstChild);
      q.reponses.forEach(function (r) {
        var li = el('li');
        var bouton = el('button', 'k9-quiz__reponse', r.texte);
        bouton.type = 'button';
        bouton.addEventListener('click', function (ev) { if (ev && ev.detail > 1) return; repondre(r.points); });
        li.appendChild(bouton);
        reponses.appendChild(li);
      });
      if (focus) question.focus();
    }

    function repondre(points) {
      for (var cle in points) totaux[cle] = (totaux[cle] || 0) + points[cle];
      etape += 1;
      if (etape < modele.questions.length) return poser(true);
      var choisi = gagnant(totaux, modele.cles);
      racine.classList.add('k9-quiz--fini');
      jeu.hidden = true;
      modele.items.forEach(function (li, i) { li.hidden = modele.cles[i] !== choisi; });
      annonce.textContent = textes.resultat;
      recommencer.hidden = false;
      annonce.focus();
    }

    function demarrer(focus) {
      etape = 0;
      totaux = {};
      racine.classList.remove('k9-quiz--fini');
      jeu.hidden = false;
      modele.items.forEach(function (li) { li.hidden = false; });
      annonce.textContent = '';
      recommencer.hidden = true;
      poser(focus);
    }

    recommencer.addEventListener('click', function () { demarrer(true); });
    racine.classList.add('k9-quiz--actif');
    demarrer(false);
    return true;
  }

  /* ---- Mode « regles » : algorithme de référence du § 3 de la spec, même résultat que tools/cms/quiz_regles.py de
     k9-seo (cas partagés rejoués par tests/test_quiz_regles.mjs). « ? » : « Je ne sais pas » (question épuisée). */
  var INCONNU = '?';
  var REPLI = 'repli';
  var IDENT = /^[a-z0-9-]+$/;
  // Blancs du HTML seulement : \s inclurait U+00A0, les insécables posées par le générateur (règle S3).
  var BLANCS = /[ \t\n\r\f]+/g;
  var DEFAUTS_REGLES = { progression: 'Question {n}', modification: 'Modifier votre réponse',
    reponses: 'Revoir mes réponses', modifier: 'Modifier', recommencer: 'Recommencer' };

  // « q=a|b;r=c » → { q: ['a', 'b'], r: ['c'] } ; vide → {} ; illisible → null.
  function lireConditions(texte) {
    var conditions = vide();
    var morceaux = String(texte || '').split(';');
    for (var i = 0; i < morceaux.length; i++) {
      var morceau = morceaux[i].trim();
      if (!morceau) continue;
      var m = /^([a-z0-9-]+)=([a-z0-9|?-]+)$/.exec(morceau);
      if (!m || conditions[m[1]]) return null;
      conditions[m[1]] = m[2].split('|');
      if (conditions[m[1]].some(function (v) { return !v; })) return null;
    }
    return conditions;
  }

  function texteDirect(li) {
    return Array.prototype.filter.call(li.childNodes, function (n) { return n.nodeType === 3; })
      .map(function (n) { return n.textContent; }).join('').replace(BLANCS, ' ').trim();
  }

  function lireRegles(racine) {
    var liste = enfant(racine, 'k9-quiz__questions');
    var regles = enfant(racine, 'k9-quiz__regles');
    var resultats = enfant(racine, 'k9-quiz__resultats');
    var modele = { liste: regles, resultats: resultats, questions: [], regles: [], items: vide(), ordre: [] };
    (liste ? enfants(liste, 'LI') : []).forEach(function (li) {
      var ul = enfants(li, 'UL')[0];
      modele.questions.push({
        id: (li.getAttribute('data-id') || '').trim(),
        libelle: texteDirect(li),
        aide: (li.getAttribute('data-aide') || '').trim(),
        si: lireConditions(li.getAttribute('data-si')),
        choix: ul ? enfants(ul, 'LI').map(function (c) {
          return { id: (c.getAttribute('data-choix') || '').trim(), libelle: c.textContent.replace(BLANCS, ' ').trim() };
        }) : []
      });
    });
    (regles ? enfants(regles, 'LI') : []).forEach(function (li) {
      modele.regles.push({ si: lireConditions(li.getAttribute('data-si')), alors: (li.getAttribute('data-alors') || '').trim(),
        guide: li.textContent.replace(BLANCS, ' ').trim() });
    });
    (resultats ? enfants(resultats, 'LI') : []).forEach(function (li) {
      var id = (li.getAttribute('data-resultat') || '').trim();
      modele.ordre.push(id);
      modele.items[id] = { li: li, action: li.hasAttribute('data-action') ? lireConditions(li.getAttribute('data-action')) : undefined,
        texteAction: (li.getAttribute('data-texte-action') || '').trim() };
    });
    return modele;
  }

  function question(modele, id) {
    for (var i = 0; i < modele.questions.length; i++) if (modele.questions[i].id === id) return modele.questions[i];
    return null;
  }

  function choixReels(q) {
    return q.choix.map(function (c) { return c.id; }).filter(function (c) { return c !== INCONNU; });
  }

  // Raison du refus, ou '' si le bloc est jouable (le conflit et le trou sont refusés par le générateur de k9-seo).
  function validerRegles(modele) {
    if (!modele.liste) return 'liste des règles absente';
    if (!modele.resultats) return 'liste des résultats absente';
    if (!modele.questions.length) return 'aucune question';
    if (!modele.regles.length) return 'aucune règle';
    var vus = [];
    for (var q = 0; q < modele.questions.length; q++) {
      var qu = modele.questions[q];
      if (!IDENT.test(qu.id) || vus.indexOf(qu.id) >= 0) return 'question ' + (q + 1) + ' : data-id invalide ou en double';
      if (!qu.libelle) return 'question ' + qu.id + ' sans libellé';
      if (!qu.si) return 'question ' + qu.id + ' : data-si illisible';
      for (var p in qu.si) {
        if (vus.indexOf(p) < 0) return 'question ' + qu.id + ' : prérequis ' + p + ' absent ou placé après';
        for (var a = 0; a < qu.si[p].length; a++) {
          if (choixReels(question(modele, p)).indexOf(qu.si[p][a]) < 0) return 'question ' + qu.id + ' : prérequis ' + p + '=' + qu.si[p][a] + ' inconnu';
        }
      }
      var ids = qu.choix.map(function (c) { return c.id; });
      if (choixReels(qu).length < 2) return 'question ' + qu.id + ' : moins de deux choix';
      for (var c = 0; c < qu.choix.length; c++) {
        var ch = qu.choix[c];
        if ((ch.id !== INCONNU && !IDENT.test(ch.id)) || ids.indexOf(ch.id) !== c || !ch.libelle) return 'question ' + qu.id + ' : choix ' + (c + 1) + ' invalide';
      }
      vus.push(qu.id);
    }
    if (!possede(modele.items, REPLI) || !modele.items[REPLI].li.hasAttribute('data-repli')) return 'résultat « repli » absent';
    for (var r = 0; r < modele.ordre.length; r++) {
      var rid = modele.ordre[r];
      if (!IDENT.test(rid) || modele.ordre.indexOf(rid) !== r) return 'résultat ' + (r + 1) + ' : data-resultat invalide ou en double';
      var item = modele.items[rid];
      if (item.action !== undefined) {
        if (!item.action || !Object.keys(item.action).length || !item.texteAction) return 'résultat ' + rid + ' : action illisible';
        for (var aq in item.action) {
          var cible = question(modele, aq);
          if (!cible || item.action[aq].length !== 1 || choixReels(cible).indexOf(item.action[aq][0]) < 0) return 'résultat ' + rid + ' : action ' + aq + ' inconnue';
        }
      }
    }
    for (var g = 0; g < modele.regles.length; g++) {
      var regle = modele.regles[g];
      if (!regle.si) return 'règle ' + (g + 1) + ' : data-si illisible';
      if (!possede(modele.items, regle.alors)) return 'règle ' + (g + 1) + ' : résultat inconnu ' + regle.alors;
      for (var rq in regle.si) {
        var qr = question(modele, rq);
        if (!qr) return 'règle ' + (g + 1) + ' : question inconnue ' + rq;
        for (var v = 0; v < regle.si[rq].length; v++) {
          if (choixReels(qr).indexOf(regle.si[rq][v]) < 0) return 'règle ' + (g + 1) + ' : choix inconnu ' + rq + '=' + regle.si[rq][v];
        }
      }
    }
    return '';
  }

  function admet(conditions, reponses) {
    for (var q in conditions) {
      if (!Object.prototype.hasOwnProperty.call(reponses, q) || conditions[q].indexOf(reponses[q]) < 0) return false;
    }
    return true;
  }

  // Objet sans prototype : un identifiant comme « constructor » n'y trouve rien d'hérité.
  function vide() { return Object.create(null); }

  function possede(objet, cle) { return Object.prototype.hasOwnProperty.call(objet, cle); }

  function copie(etat) {
    var c = vide();
    for (var k in etat) c[k] = etat[k];
    return c;
  }

  // Étape 1 : retirer les réponses aux questions dont les prérequis ne sont plus satisfaits, jusqu'à stabilité.
  function stabiliser(modele, etat) {
    etat = copie(etat);
    var change = true;
    while (change) {
      change = false;
      modele.questions.forEach(function (q) {
        if (Object.prototype.hasOwnProperty.call(etat, q.id) && !admet(q.si, etat)) { delete etat[q.id]; change = true; }
      });
    }
    return etat;
  }

  // Étape 2 : complétions de l'état ; « sans objet » vaut null, l'applicabilité est évaluée dans la complétion.
  function completions(modele, etat) {
    var qs = modele.questions;
    var sortie = [];
    var c = vide();
    (function rec(i) {
      if (i === qs.length) { sortie.push(copie(c)); return; }
      var q = qs[i];
      if (!admet(q.si, c)) { c[q.id] = null; rec(i + 1); delete c[q.id]; return; }
      var valeurs = possede(etat, q.id) && etat[q.id] !== INCONNU ? [etat[q.id]] : choixReels(q);
      for (var v = 0; v < valeurs.length; v++) { c[q.id] = valeurs[v]; rec(i + 1); }
      delete c[q.id];
    })(0);
    return sortie;
  }

  // Étape 3 : identifiant unique, « trou » (aucune règle) ou « conflit » (plusieurs résultats).
  function issue(modele, a) {
    var ids = [];
    modele.regles.forEach(function (r) { if (admet(r.si, a) && ids.indexOf(r.alors) < 0) ids.push(r.alors); });
    return ids.length === 1 ? ids[0] : ids.length ? 'conflit' : 'trou';
  }

  // D(q) : q et les questions dont les prérequis citent q, de proche en proche.
  function dependants(modele, id) {
    var d = [id];
    var change = true;
    while (change) {
      change = false;
      modele.questions.forEach(function (q) {
        if (d.indexOf(q.id) < 0 && Object.keys(q.si).some(function (p) { return d.indexOf(p) >= 0; })) { d.push(q.id); change = true; }
      });
    }
    return d;
  }

  // Étape 7, en temps linéaire : complétions regroupées selon leurs valeurs hors de D(q).
  function pertinente(modele, comps, id) {
    var d = dependants(modele, id);
    var hors = modele.questions.map(function (q) { return q.id; }).filter(function (q) { return d.indexOf(q) < 0; });
    var groupes = vide();
    comps.forEach(function (c) {
      var cle = JSON.stringify(hors.map(function (q) { return c.a[q]; }));
      var parValeur = groupes[cle] || (groupes[cle] = vide());
      var issues = parValeur[c.a[id]] || (parValeur[c.a[id]] = []);
      if (issues.indexOf(c.issue) < 0) issues.push(c.issue);
    });
    for (var cle in groupes) {
      var valeurs = Object.keys(groupes[cle]);
      for (var i = 0; i < valeurs.length; i++) {
        for (var j = i + 1; j < valeurs.length; j++) {
          var i1 = groupes[cle][valeurs[i]];
          var i2 = groupes[cle][valeurs[j]];
          if (i1.some(function (x) { return i2.some(function (y) { return x !== y; }); })) return true;
        }
      }
    }
    return false;
  }

  // { question: id } | { issue: id } | { repli: [positions des règles encore possibles] } (format de quiz-cas.json).
  function decider(modele, etat) {
    etat = stabiliser(modele, etat);
    var comps = completions(modele, etat).map(function (a) { return { a: a, issue: issue(modele, a) }; });
    var issues = [];
    comps.forEach(function (c) { if (issues.indexOf(c.issue) < 0) issues.push(c.issue); });
    if (issues.length === 1) return { issue: issues[0] === 'trou' ? REPLI : issues[0] };
    for (var i = 0; i < modele.questions.length; i++) {
      var q = modele.questions[i];
      var posable = !Object.prototype.hasOwnProperty.call(etat, q.id) && admet(q.si, etat);
      if (posable && pertinente(modele, comps, q.id)) return { question: q.id };
    }
    var possibles = [];
    modele.regles.forEach(function (r, n) { if (comps.some(function (c) { return admet(r.si, c.a); })) possibles.push(n); });
    return { repli: possibles };
  }

  function appliquerAction(modele, etat, resultat) {
    var nouveau = copie(etat);
    var action = modele.items[resultat].action;
    for (var q in action) nouveau[q] = action[q][0];
    return stabiliser(modele, nouveau);
  }

  function modifier(modele, etat, id, valeur) {
    var nouveau = copie(etat);
    nouveau[id] = valeur;
    return stabiliser(modele, nouveau);
  }

  function initialiserRegles(racine) {
    var modele = lireRegles(racine);
    var raison = validerRegles(modele);
    if (!raison) {
      // Premier calcul avant toute écriture dans la page : jamais de bloc à moitié initialisé.
      try { decider(modele, {}); } catch (e) { raison = 'calcul impossible (' + e.message + ')'; }
    }
    if (raison) {
      console.warn('[k9-quiz] bloc laissé tel quel : ' + raison);
      return false;
    }
    racine.setAttribute('data-k9-quiz-pret', '');
    var doc = racine.ownerDocument;
    // Rang du bloc dans la page : identifiants uniques, même si le script est exécuté deux fois.
    var n = Array.prototype.indexOf.call(doc.querySelectorAll('[data-k9-quiz]'), racine) + 1;
    var textes = {};
    for (var k in DEFAUTS_REGLES) textes[k] = racine.getAttribute('data-texte-' + k) || DEFAUTS_REGLES[k];
    function el(tag, classe, texte) {
      var e = doc.createElement(tag);
      if (classe) e.className = classe;
      if (texte != null) e.textContent = texte;
      return e;
    }
    function bouton(classe, texte, action) {
      var b = el('button', classe, texte);
      b.type = 'button';
      b.addEventListener('click', function (ev) { if (ev && ev.detail > 1) return; action(); });
      return b;
    }

    var jeu = el('div', 'k9-quiz__jeu');
    var enonce = el('p', 'k9-quiz__question');
    enonce.setAttribute('tabindex', '-1');
    enonce.setAttribute('id', 'k9-quiz-' + n + '-question');
    var progression = el('span', 'k9-quiz__progression');
    var libelle = el('span', 'k9-quiz__libelle');
    enonce.appendChild(progression);
    enonce.appendChild(libelle);
    var aide = el('p', 'k9-quiz__aide');
    aide.setAttribute('id', 'k9-quiz-' + n + '-aide');
    var reponses = el('ul', 'k9-quiz__reponses');
    // Groupe porté par le conteneur : sur la liste, role="group" masquerait ses li (règle axe listitem).
    jeu.setAttribute('role', 'group');
    jeu.setAttribute('aria-labelledby', 'k9-quiz-' + n + '-question');
    jeu.appendChild(enonce);
    jeu.appendChild(aide);
    jeu.appendChild(reponses);
    var recap = el('details', 'k9-quiz__recap');
    recap.appendChild(el('summary', null, textes.reponses));
    var liste = el('dl', 'k9-quiz__recap-liste');
    recap.appendChild(liste);
    var recommencer = bouton('k9-quiz__recommencer', textes.recommencer, function () { demarrer(true); });
    racine.insertBefore(jeu, modele.resultats);
    racine.appendChild(recap);
    racine.appendChild(recommencer);
    modele.liste.hidden = true;
    modele.resultats.hidden = false;

    var etat = {};
    var enModification = null;
    var guides = null;

    function vider(e) { while (e.firstChild) e.removeChild(e.firstChild); }

    function retirerGuides() {
      if (guides && guides.parentNode) guides.parentNode.removeChild(guides);
      guides = null;
    }

    function poser(id, focus) {
      var q = question(modele, id);
      racine.classList.remove('k9-quiz--fini');
      jeu.hidden = false;
      recap.hidden = true;
      modele.ordre.forEach(function (r) { modele.items[r].li.hidden = true; });
      retirerGuides();
      recommencer.hidden = !Object.keys(etat).length;
      progression.textContent = enModification ? textes.modification
        : textes.progression.replace('{n}', String(Object.keys(etat).length + 1));
      libelle.textContent = q.libelle;
      aide.textContent = q.aide;
      aide.hidden = !q.aide;
      if (q.aide) jeu.setAttribute('aria-describedby', 'k9-quiz-' + n + '-aide');
      else jeu.removeAttribute('aria-describedby');
      vider(reponses);
      q.choix.forEach(function (c) {
        var li = el('li');
        li.appendChild(bouton('k9-quiz__reponse', c.libelle, function () { repondre(q.id, c.id); }));
        reponses.appendChild(li);
      });
      if (focus) enonce.focus();
    }

    function repondre(id, valeur) {
      if (enModification) etat = modifier(modele, etat, id, valeur);
      else { etat[id] = valeur; etat = stabiliser(modele, etat); }
      enModification = null;
      avancer(true);
    }

    function remplirRecap() {
      vider(liste);
      modele.questions.forEach(function (q) {
        if (!Object.prototype.hasOwnProperty.call(etat, q.id)) return;
        var choix = q.choix.filter(function (c) { return c.id === etat[q.id]; })[0];
        var ligne = el('div', 'k9-quiz__recap-ligne');
        ligne.appendChild(el('dt', null, q.libelle));
        var dd = el('dd', null, choix ? choix.libelle : etat[q.id]);
        var b = bouton('k9-quiz__modifier', textes.modifier, function () { enModification = q.id; poser(q.id, true); });
        b.setAttribute('aria-label', textes.modifier + ' : ' + q.libelle);
        dd.appendChild(b);
        ligne.appendChild(dd);
        liste.appendChild(ligne);
      });
    }

    function montrer(id, positions, focus) {
      if (!possede(modele.items, id)) id = REPLI;
      var item = modele.items[id];
      racine.classList.add('k9-quiz--fini');
      jeu.hidden = true;
      recommencer.hidden = false;
      modele.ordre.forEach(function (r) { modele.items[r].li.hidden = modele.items[r] !== item; });
      retirerGuides();
      if (item === modele.items[REPLI] && positions && positions.length) {
        guides = el('ul', 'k9-quiz__guides');
        positions.forEach(function (p) { guides.appendChild(el('li', null, modele.regles[p].guide)); });
        item.li.appendChild(guides);
      }
      if (item.action && !item.bouton) {
        item.bouton = bouton('k9-quiz__action', item.texteAction, function () {
          etat = appliquerAction(modele, etat, id);
          avancer(true);
        });
        item.li.appendChild(item.bouton);
      }
      remplirRecap();
      recap.hidden = !liste.children.length;
      var titre = enfants(item.li, 'STRONG')[0] || item.li;
      titre.setAttribute('tabindex', '-1');
      if (focus) titre.focus();
    }

    function avancer(focus) {
      var d = decider(modele, etat);
      if (d.question) return poser(d.question, focus);
      if (d.issue) return montrer(d.issue, null, focus);
      montrer(REPLI, d.repli, focus);
    }

    function demarrer(focus) {
      etat = {};
      enModification = null;
      avancer(focus);
    }

    racine.classList.add('k9-quiz--actif');
    racine.classList.add('k9-quiz--regles');
    demarrer(false);
    return true;
  }

  globalThis.K9Quiz = { lirePoints: lirePoints, valider: valider, gagnant: gagnant, initialiser: initialiser,
    regles: { lireConditions: lireConditions, lire: lireRegles, valider: validerRegles, stabiliser: stabiliser,
      decider: decider, appliquerAction: appliquerAction, modifier: modifier } };
  Array.prototype.forEach.call(document.querySelectorAll('[data-k9-quiz]'), function (racine) {
    try { initialiser(racine); } catch (e) { console.warn('[k9-quiz] erreur : ' + e.message); }
  });
})();
